// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__37YQj","productName":"Table_productName__3Qhzu"};